import type * as Types from '../../../graphql/generated-base';

import type { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@graphql/react-hooks';
export type EventDesignLayoutTypeQueryVariables = Types.Exact<{
  eventHandle: Types.Scalars['String'];
  eventDesignPurpose?: Types.InputMaybe<Types.EventDesignPurpose>;
}>;

export type EventDesignLayoutTypeQuery = {
  __typename?: 'Query';
  eventByName?: {
    __typename?: 'Event';
    id: string;
    eventDesign?: { __typename?: 'EventDesign'; id: string; websiteLayout: { __typename?: 'DesignLayout'; id: string; layoutType: Types.DesignLayoutType } } | null;
  } | null;
};

export const EventDesignLayoutTypeDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'EventDesignLayoutType' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventHandle' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventDesignPurpose' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'EventDesignPurpose' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'eventByName' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'name' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'eventHandle' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'eventDesign' },
                  arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'purpose' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'eventDesignPurpose' } } }],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'websiteLayout' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'layoutType' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useEventDesignLayoutTypeQuery__
 *
 * To run a query within a React component, call `useEventDesignLayoutTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventDesignLayoutTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventDesignLayoutTypeQuery({
 *   variables: {
 *      eventHandle: // value for 'eventHandle'
 *      eventDesignPurpose: // value for 'eventDesignPurpose'
 *   },
 * });
 */
export function useEventDesignLayoutTypeQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<EventDesignLayoutTypeQuery, EventDesignLayoutTypeQueryVariables>) {
  return ApolloReactHooks.useQuery<EventDesignLayoutTypeQuery, EventDesignLayoutTypeQueryVariables>(EventDesignLayoutTypeDocument, baseOptions);
}
export function useEventDesignLayoutTypeLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<EventDesignLayoutTypeQuery, EventDesignLayoutTypeQueryVariables>) {
  return ApolloReactHooks.useLazyQuery<EventDesignLayoutTypeQuery, EventDesignLayoutTypeQueryVariables>(EventDesignLayoutTypeDocument, baseOptions);
}
export type EventDesignLayoutTypeQueryHookResult = ReturnType<typeof useEventDesignLayoutTypeQuery>;
export type EventDesignLayoutTypeLazyQueryHookResult = ReturnType<typeof useEventDesignLayoutTypeLazyQuery>;
export type EventDesignLayoutTypeQueryResult = Apollo.QueryResult<EventDesignLayoutTypeQuery, EventDesignLayoutTypeQueryVariables>;
